import ClientReceiver from "./ClientReceiver";

export default ClientReceiver;
